var Model = require("../types/Model");

module.exports = Model({
	name: "orgmultifactor",
	init: init,
	uninit: uninit,
	listeners: listeners,
	refresh: refresh
});

function init() {
	this._tracker = this.dispatcher.createTracker();
	this.refresh();
}

function uninit() {
	this._tracker.off();
	this._tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"orggroup:updated": handle_orggroup_update
	};
}

function refresh() {
	return this.api.org.staff.get.multifactor()
		.then(handle_set_multifactor.bind(this));
}

function handle_orggroup_update(orggroup) {
	var orgGroup = orggroup;
	if (!orggroup) return;

	var tracker = this._tracker;

	tracker.off();
	tracker.on("mqtt:orggroup/" + orgGroup + "/multifactor", handle_set_multifactor.bind(this));
}

function handle_set_multifactor(data) {
	this.push(data);
}
